<template>
  <div class="loginForm">
    <v-card class="mx-auto" max-width="95%">
      <v-list-item-title class="headline mb-1">
        Researcher Change Password
        <h1 class="d-sr-only">Researcher Change Password</h1>
				<h2 v-show="shouldChangePassword" class="subtitle-1 font-weight-regular font-red">Your password has expired. Please change your password to continue.</h2>
      </v-list-item-title>
      <v-card-subtitle> The password must be: </v-card-subtitle>
      <v-card-text>
        <ul>
          <li class="text-left">Minimum 15 characters</li>
          <li class="text-left">
            have at least one special character (no single or double quotes)
          </li>
          <li class="text-left">
            have a combination of letters and numbers and/or a combination of
            upper and lower case letters
          </li>
        </ul>
      </v-card-text>
      <v-divider></v-divider>
      <div>
        <v-card-subtitle> Fields marked with * are required.</v-card-subtitle>
        <v-form ref="form" align="center" v-model="valid">
          <!-- new container set up for icons with aria-labels -->
          <v-container>
            <v-row>
              <v-text-field
                v-model="oldPassword"
                label="*Old Password"
                :rules="oldPasswordRules"
                required
                :type="show0 ? 'text' : 'password'"
              ></v-text-field>
              <v-icon
                v-if="show0"
								class="iconShowHide"
                @click="show0 = !show0"
                aria-label="Click to hide old password"
              >
                mdi-eye
              </v-icon>
              <v-icon
                v-else
								class="iconShowHide"
                @click="show0 = !show0"
                aria-label="Click to show old password"
              >
                mdi-eye-off
              </v-icon>
            </v-row>
            <v-row>
              <v-text-field
                v-model="newPassword"
                label="*New Password"
                :rules="newPasswordRules"
                required
                :error-messages="passwordShouldNotMatchError()"
                :type="show1 ? 'text' : 'password'"
              ></v-text-field>
              <v-icon
                v-if="show1"
								class="iconShowHide"
                @click="show1 = !show1"
                aria-label="Click to hide new password"
              >
                mdi-eye
              </v-icon>
              <v-icon
                v-else
								class="iconShowHide"
                @click="show1 = !show1"
                aria-label="Click to show new password"
              >
                mdi-eye-off
              </v-icon>
            </v-row>
            <v-row>
              <v-text-field
                v-model="confirmPassword"
                label="*Confirm Password"
                :rules="confirmPasswordRules"
                required
                :error-messages="passwordMatchError()"
                :type="show2 ? 'text' : 'password'"
              ></v-text-field>
              <v-icon
                v-if="show2"
								class="iconShowHide"
                @click="show2 = !show2"
                aria-label="Click to hide confirm password"
              >
                mdi-eye
              </v-icon>
              <v-icon
                v-else
								class="iconShowHide"
                @click="show2 = !show2"
                aria-label="Click to show confirm password"
              >
                mdi-eye-off
              </v-icon>
            </v-row>
          </v-container>
          <!-- old text fields,icons have no descriptive aria-labels -->
          <!-- <v-text-field
            v-model="oldPassword"
            label="*Old Password"
						:rules="oldPasswordRules"
            required
						:type="show0 ? 'text' : 'password'"
						:append-icon="show0 ? 'mdi-eye' : 'mdi-eye-off'"
						aria-label:append="hello"
						@click:append="show0 = !show0"
          ></v-text-field>
          <v-text-field
            v-model="newPassword"
            label="*New Password"
            :rules="newPasswordRules"
            required
						:error-messages="passwordShouldNotMatchError()"
						:type="show1 ? 'text' : 'password'"
						:append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="show1 = !show1"
          ></v-text-field>
          <v-text-field
            v-model="confirmPassword"
            label="*Confirm Password"
            :rules="confirmPasswordRules"
            required
						:error-messages="passwordMatchError()"
						:type="show2 ? 'text' : 'password'"
						:append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
						@click:append="show2 = !show2"
          ></v-text-field> -->
          <v-btn @click="canceledForm">Cancel</v-btn>
          <v-btn
            class="btn-default"
            text
						:loading="isLoading"
            :disabled="!valid"
            @click="submitForm"
          >
            Submit
          </v-btn>
        </v-form>
      </div>
    </v-card>
  </div>
</template>

<script>
import { authService } from '@/services/authService.js';

export default {
	name: 'PasswordForm',
	data: () => ({
		valid: true,
		oldPassword: null,
		newPassword: null,
		confirmPassword: null,
		oldPasswordRules: [(v) => !!v || 'Old Password is required'],
		newPasswordRules: [
			(v) => !!v || 'New Password is required',
			(v) => /(?=.{15})/.test(v) || 'Minimum 15 characters',
			(v) => /(?=.*?[#?!@$%^&*-])/.test(v) || 'Must contain speacial character',
			(v) => /(?=.*[A-Za-z](?=.*\d))/.test(v) ||
        /(?=.*[a-z](?=.*[A-Z]))/.test(v) ||
        'Must contain at least one letter and one number and/or a combination of upper and lower case letters'],
		confirmPasswordRules: [(v) => !!v || 'Confirm Password is required'],
		show0: false,
		show1: false,
		show2: false,
		isLoading: false
	}),
	beforeMount () {},
	methods: {
		canceledForm () {
			const me = this;
			me.$router.push('/profile');
		},
		async submitForm () {
			this.isLoading = true;
			const me = this;
			var myUserId = await this.$store.getters.getUserId;
			const submitObj = {
				userUuid: myUserId,
				userName: this.userInfo.firstName,
				oldPassword: me.oldPassword,
				newPassword: me.newPassword
			};
			await authService
				.changeUserPassword(submitObj, myUserId)
				.then(function (response) {
					me.isLoading = false;
					console.log('ChangePassword response:', JSON.stringify(response));
					me.$store.commit('setShouldChangePassword', { shouldChangePassword: response.data.shouldChangePassword });
					me.$store.dispatch('changeUpdateStatus', {
						status: 'password-update-success'
					});
					me.$router.push('/landing');
				})
				.catch(function (e) {
					me.isLoading = false;
					let errorMessage = 'Change password failed.';
					if (e.response.data.messages) {
						errorMessage = e.response.data.messages[0];
					}
					me.$store.dispatch('changeUpdateStatusWithMessage', {
						status: 'password-update-fail',
						message: errorMessage
					});
				});
		},
		passwordShouldNotMatchError () {
			if (this.newPassword !== null) {
				return this.oldPassword !== this.newPassword
					? ''
					: 'New Password must be different from Old Password';
			}
		},
		passwordMatchError () {
			if (this.confirmPassword !== null) {
				return this.newPassword === this.confirmPassword
					? ''
					: 'New Password and Confirm Password must match';
			}
		}
	},

	computed: {
		userInfo: function () {
			return this.$store.getters.getUserInfo;
		},
		shouldChangePassword: function () {
			return this.$store.getters.getShouldChangePassword;
		}
	}
};
</script>

<style>
.v-text-field,
.v-btn {
  margin: 10px;
}
.iconShowHide {
  margin-right: 10px;
}
</style>
